import React from 'react';
import PageLoader from '../../components/Common/loader/PageLoader';

import Filters from '../../components/Common/Filters/Filters';

import { Data } from './data';
import PlanningWindowConfigurationTable from './Table/PlanningWindowConfigurationTable';

interface Props {
  history: any;
}

interface State {
  isLoading: boolean;
  isFilterApplied: boolean;
  isCallRequired: boolean;
  isTableLoading: boolean;
  dataSource: any;
}

export default class PlanningWindowConfiguration extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      dataSource: Data,
      isFilterApplied: false,
      isCallRequired: false,
      isLoading: false,
      isTableLoading: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isTableLoading !== this.state.isTableLoading) {
      this.setState({ isLoading: this.state.isTableLoading });
    }
  }

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <div className="page-content">

          <PageLoader
            status={this.state.isLoading}
          />
          <Filters
            timeSelection={'multi'}
            history={this.props.history}
            onUpdateFilter={() => {
              this.setState({
                isFilterApplied: true,
                isCallRequired: true,
                isLoading: true,
                isTableLoading: true
              });
            }}
          />

          {
            this.state.isFilterApplied &&
            <PlanningWindowConfigurationTable
              history={this.props.history}
              isCallRequired={this.state.isCallRequired}
              onLoadEnd={() => {
                this.setState({
                  isCallRequired: false,
                  isTableLoading: false
                });
              }}
              onUpdateStart={() => this.setState({ isLoading: true })}
              onUpdateEnd={() => {
                this.setState({
                  isCallRequired: true,
                  isTableLoading: true
                });
              }}
            />
          }
        </div>
      </React.Fragment>
    );
  }
}
